import { ContentData } from "../../src/apis/stateful-content";
import { ColumnTypes } from "../../src/components/stateful-content/stateful-table/column-types";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;
import { StatusType } from "@trumpf/ux.ui-widgets/dist/collection/components/status/status-types";

const active: StatusType = "SERVICE_AGREEMENT_Active";
const inactive: StatusType = "SERVICE_AGREEMENT_Inactive";

const response: ContentData = {
    totalCount: 62,
    filteredCount: 62,
    labelCount: "Treffer",
    schema: {
        isFav: {
            type: ColumnTypes.FavToggle,
            sortable: true,
            "primary-mobile": false,
        },
        name: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": true,
        },
        latestAvailableVersion: {
            type: ColumnTypes.LatestAvailableSoftwareVersion,
            sortable: false,
            "primary-mobile": false,
        },
        serviceAgreementStatus: {
            type: ColumnTypes.Status,
            sortable: false,
            "primary-mobile": false,
        },
        detailLink: {
            type: ColumnTypes.DetailLink,
            sortable: false,
            "primary-mobile": false,
        },
    },
    items: [
        {
            name: "Demo TruTops Boost TEST",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "9.5", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: true,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902844527&cHash=d106e51f0794be48661e811712e685e2",
        },
        {
            name: "Materialdescription for 1948519",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "11.02.22.00",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: true,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902898715&cHash=ef80c4e3827165d5d7eb457f160b9c57",
        },
        {
            name: "PC-Transfer",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "4.20.00.0",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: true,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900751944&cHash=07552b60f524d1fa18bb140309c09a5c",
        },
        {
            name: "PC-Transfer",
            serviceAgreementStatus: active,
            latestAvailableVersion: {
                version: "4.20.00.0",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900554940&cHash=62a5637d120c39f1f11f79aa5bc4ed71",
        },
        {
            name: "TruTops",
            serviceAgreementStatus: active,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900554948&cHash=2125d5bcf5f245aff1971c3b363798f8",
        },
        {
            name: "TruTops",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900567842&cHash=24ee823e7279418d1e1dc42b32b17907",
        },
        {
            name: "TruTops",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900751948&cHash=18e6535bcce9753ad00c8901d15ed5b6",
        },
        {
            name: "TruTops",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=901666472&cHash=4bdb9b5e8bc3e43d2f67401a1c52da07",
        },
        {
            name: "TruTops",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902377822&cHash=555f455649ec8bee5dd2b6a36531a280",
        },
        {
            name: "TruTops Bend",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900555353&cHash=2044db772d6f1f0bac8bad64cf950c26",
        },
        {
            name: "TruTops Bend",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900567850&cHash=42db2125462545372787ad4c8ff54afd",
        },
        {
            name: "TruTops Boost 1.Liz.",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "8.4", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902792365&cHash=70661c8bd01f127bb95ab0634c7dd2cb",
        },
        {
            name: "TruTops Boost 1.Liz.",
            serviceAgreementStatus: active,
            latestAvailableVersion: {
                version: "12.04.21.00",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902930074&cHash=f9ae043c620ec13ff8e6b0d0e2fdec16",
        },
        {
            name: "TruTops Boost 1.Liz.",
            serviceAgreementStatus: active,
            latestAvailableVersion: {
                version: "14.06.21.00",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902967741&cHash=65d3e39fc381782e5e616c51293c09f6",
        },
        {
            name: "TruTops CAD",
            serviceAgreementStatus: active,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900554976&cHash=45539ce2e7b991f2e61ead201b323dcc",
        },
        {
            name: "TruTops CAD",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900567897&cHash=6061a48c1c322a64205ca8b16d95523b",
        },
        {
            name: "TruTops CAD",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=901666469&cHash=b3c252ee01988a09cbac0b7f217a4d30",
        },
        {
            name: "TruTops CAD",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902377819&cHash=1b40bc4a331b074a2c06802f0c576684",
        },
        {
            name: "TruTops Cell",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "09.06.00", hasUpdates: true },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=901367803&cHash=4ede4d1a715c7dd8e5ab99edc311cfd4",
        },
        {
            name: "TruTops Cell",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "9.00.00.0", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=901557016&cHash=6db0e223c86078297efc22467d49c4cf",
        },
        {
            name: "TruTops Cell",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "8.01.00.0", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902128054&cHash=ae2a8d9170d737b73216c8e81f139c87",
        },
        {
            name: "TruTops Cell",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "7.01.00.0", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902129449&cHash=0cca5497b5e210d1acbcc468abdd4d3b",
        },
        {
            name: "TruTops Cell",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "8.01.00.0", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902377795&cHash=de026ea84c5d8dbf607c80508e799340",
        },
        {
            name: "TruTops Fab",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "16.05.20.00",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902792366&cHash=b7cd34d9d2d25f66004300b9bb01645e",
        },
        {
            name: "TruTops Fab",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "21.04.21.00",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902930075&cHash=ae8dbb09016f02de6fc559c76c9aa234",
        },
        {
            name: "TruTops Fab",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "22.05.22.01",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902967742&cHash=c0881afeae6b517f26215bd8ab70de87",
        },
        {
            name: "TruTops Laser (metrisch)",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900751982&cHash=4cb2caecf9883d9482fd3e60f0fc4427",
        },
        {
            name: "TruTops Laser (metrisch)",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=901666457&cHash=ebd5686921245da4377660b1106a4787",
        },
        {
            name: "TruTops Laser (metrisch)",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902128049&cHash=8cccc63124c997c3c15252cc4d110e9a",
        },
        {
            name: "TruTops Laser (metrisch)",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902377781&cHash=94b98bfb4172f21e2e4912dc2610fca8",
        },
        {
            name: "TruTops Punch (metrisch)",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900555040&cHash=c87bc49f5c140c29040313d5d11bd1aa",
        },
    ],
};

const writeToFile = (object: ContentData, name: string) => {
    console.log(JSON.stringify(object));
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

const response1 = {
    ...response
};

writeToFile(response1, "stateful-content");
